import { saveUserDataBase } from '../../common/logic/respondent_data.js';

const saveUserData = (url, status, result, data) => {
  saveUserDataBase(url, status, result, data);
};

export default saveUserData;
